<div class="container-fluid bg-fondo p-5">
    <div class="justify-content-center">
      <p>¡Cuéntanos cómo deseas avanzar en tu proceso</p>
        <p>con nosotros y así poderte brindar apoyo para que</p>
        <p>alcances tus metas!</p>
      <div class="button-position">
        <button class="btn response_yes font-weight-bold btn-block" [routerLink]="['/cesion-cupo']"> 
            Realizaré cesión
        </button>
        <button class="btn response_no font-weight-bold btn-block" [routerLink]="['/desistir-nominacion']">
            Desisto de adjudicación
        </button>
      </div>
      <div class="button-position">
        <button *ngIf="actPetition.processStatus !== 'Rejected'" type="button" class="btn btn-primary font-weight-bold m-2" title="Volver" (click)="onBack()">
          <i class="fas fa-arrow-left"></i>
          Volver
        </button>   
      </div>      
    </div>
</div>
